module.exports = __webpack_public_path__ + "media/assets/fonts/din-bold_-20720c3ac567a72d0ef973d2e703dfae.otf";